/* tslint:disable */
/* eslint-disable */
/**
 * Distributor API
 * The Cashlink Distributor API enables you to distribute crypto securities and digital securities. It contains all building blocks from investor registration and KYC/AML to brokerage, clearing and settlement processes. While you are in full control of the frontends served to your investors you can use the Cashlink Studio to monitor and manage the activity on your platform.   Note: You cannot access data of investors or investments if they haven\'t been created via the API with your provided API credentials. Also, it\'s not possible to access data of investors that have registered via the Cashlink Signing Module, if you are using this as well.  ### Authentication  Every call to the API must be authenticated via OAuth client credentials. During setup, your point of contact will provide you with your client ID and client secret.   ### Idempotency  For certain POST endpoints, the API uses client-supplied idempotency keys to ensure that requests can be retried safely without performing the same operation twice. Repeated calls to those endpoints with the same idempotency key will return the cached response from the first call. Keys are expected to be set as header parameters with *X-Idempotency-Key*. The recommended approach for interacting with such endpoints is as follows:   - Create a unique, random key, such as a UUIDv4.   - Store the intent to call an endpoint along with the generated key in the client database.   - Flush to disk (e.g. commit an SQL transaction).   - Perform the call to the endpoint.   This ensures that even if the response from the API to a client gets lost, or the client experiences any sort of outage between steps 3 and 4, the client can always safely retry the same action.   If you already have objects corresponding to tasks in the API in your client-side database, you can use their internal IDs as idempotency keys!   ### Monetary values   Monetary values are represented as a combination of amount, decimals & currency. For example, ```{\'amount\': \'40000000\', \'decimals\': 3, \'currency\': \'EUR\'} means \'EUR 40,000.000\'```.   ### Handling documents  The document endpoint can be used to upload documents. Files are uploaded via HTTP multipart. The endpoint will return a document ID that can be used in other requests to refer to that document.   ### Webhooks  You can also register webhooks so that we can notify your application about events with regards to investments. To use that, please provide your point of contact at Cashlink with the following data:   - URL to be used as the target for webhooks  - OAuth client credentials or bearer authentication token so that we can authenticate at your server.  Webhooks are sent every time the status of an investment changes.  **POST <customer-provided URL>**  Webhooks are retried until the called endpoint returns a 2xx.  **Request**  {  \'investment_id\': \'3fa85f64-5717-4562-b3fc-2c963f66afa6\',  \'status\': \'ACCEPTED\',  \'changed_at\': \'2020-12-11T14:59:46.716Z\'  }  ### Concepts  The Cashlink Distributor API is based on the following concepts:  - Persons (legal or natural) that are users on your platform willing to invest are called investors.  - These investors will be able to invest into different financial products issued by different entities. In the API they are called products.  - The purchase of units of such a product takes place within your application and ends with a signed investment contract.  - Now you can create an investment, which contains the investor, the units, the signed investment contract and the accepted date of the investment by the issuer.   - At some point, parts of the investments are returned to the issuer because the outstanding amount has been paid back for example. Such a transaction is called a redemption.    
 *
 * The version of the OpenAPI document: v2
 * Contact: support@cashlink.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CapitalTypeEnum } from './CapitalTypeEnum';
import {
    CapitalTypeEnumFromJSON,
    CapitalTypeEnumFromJSONTyped,
    CapitalTypeEnumToJSON,
} from './CapitalTypeEnum';

/**
 * 
 * @export
 * @interface AdminCostsVariables
 */
export interface AdminCostsVariables {
    /**
     * Fremdkapital (debt capital) oder Eigenkapital (equity capital)
     * @type {CapitalTypeEnum}
     * @memberof AdminCostsVariables
     */
    capitalType: CapitalTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof AdminCostsVariables
     */
    productStartDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminCostsVariables
     */
    productEndDate?: Date | null;
    /**
     * runtime in years, 0 for undefined
     * @type {number}
     * @memberof AdminCostsVariables
     */
    runtimeYears?: number;
    /**
     * prozentuale Kosten der Vermittlung auf das Nominalkapital Einmalkosten
     * @type {string}
     * @memberof AdminCostsVariables
     */
    costsBrokerageNominalAmountPercent: string;
    /**
     * prozentuale Zuwendung auf den Nominalbetrag Einmalkosten
     * @type {string}
     * @memberof AdminCostsVariables
     */
    grantsNominalAmountPercent: string;
    /**
     * prozentuale Kosten der Vermittlung auf den NAV laufende Kosten
     * @type {string}
     * @memberof AdminCostsVariables
     */
    costsBrokerageNavPercent: string;
    /**
     * prozentuale Zuwendungen auf den NAV laufende Kosten
     * @type {string}
     * @memberof AdminCostsVariables
     */
    grantsNavPercent: string;
    /**
     * prozentuale Transaktions- und Depotkosten auf das Nominalkapital Einmalkosten
     * @type {string}
     * @memberof AdminCostsVariables
     */
    costsTransactionDepotNominalAmountPercent: string;
    /**
     * prozentuale Transaktions- und Depotkosten auf den NAV laufend
     * @type {string}
     * @memberof AdminCostsVariables
     */
    costsTransactionDepotNavPercent: string;
}



/**
 * Check if a given object implements the AdminCostsVariables interface.
 */
export function instanceOfAdminCostsVariables(value: object): value is AdminCostsVariables {
    if (!('capitalType' in value) || value['capitalType'] === undefined) return false;
    if (!('costsBrokerageNominalAmountPercent' in value) || value['costsBrokerageNominalAmountPercent'] === undefined) return false;
    if (!('grantsNominalAmountPercent' in value) || value['grantsNominalAmountPercent'] === undefined) return false;
    if (!('costsBrokerageNavPercent' in value) || value['costsBrokerageNavPercent'] === undefined) return false;
    if (!('grantsNavPercent' in value) || value['grantsNavPercent'] === undefined) return false;
    if (!('costsTransactionDepotNominalAmountPercent' in value) || value['costsTransactionDepotNominalAmountPercent'] === undefined) return false;
    if (!('costsTransactionDepotNavPercent' in value) || value['costsTransactionDepotNavPercent'] === undefined) return false;
    return true;
}

export function AdminCostsVariablesFromJSON(json: any): AdminCostsVariables {
    return AdminCostsVariablesFromJSONTyped(json, false);
}

export function AdminCostsVariablesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCostsVariables {
    if (json == null) {
        return json;
    }
    return {
        
        'capitalType': CapitalTypeEnumFromJSON(json['capital_type']),
        'productStartDate': json['product_start_date'] == null ? undefined : (new Date(json['product_start_date'])),
        'productEndDate': json['product_end_date'] == null ? undefined : (new Date(json['product_end_date'])),
        'runtimeYears': json['runtime_years'] == null ? undefined : json['runtime_years'],
        'costsBrokerageNominalAmountPercent': json['costs_brokerage_nominal_amount_percent'],
        'grantsNominalAmountPercent': json['grants_nominal_amount_percent'],
        'costsBrokerageNavPercent': json['costs_brokerage_nav_percent'],
        'grantsNavPercent': json['grants_nav_percent'],
        'costsTransactionDepotNominalAmountPercent': json['costs_transaction_depot_nominal_amount_percent'],
        'costsTransactionDepotNavPercent': json['costs_transaction_depot_nav_percent'],
    };
}

export function AdminCostsVariablesToJSON(value?: AdminCostsVariables | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'capital_type': CapitalTypeEnumToJSON(value['capitalType']),
        'product_start_date': value['productStartDate'] == null ? undefined : ((value['productStartDate'] as any).toISOString().substring(0,10)),
        'product_end_date': value['productEndDate'] == null ? undefined : ((value['productEndDate'] as any).toISOString().substring(0,10)),
        'runtime_years': value['runtimeYears'],
        'costs_brokerage_nominal_amount_percent': value['costsBrokerageNominalAmountPercent'],
        'grants_nominal_amount_percent': value['grantsNominalAmountPercent'],
        'costs_brokerage_nav_percent': value['costsBrokerageNavPercent'],
        'grants_nav_percent': value['grantsNavPercent'],
        'costs_transaction_depot_nominal_amount_percent': value['costsTransactionDepotNominalAmountPercent'],
        'costs_transaction_depot_nav_percent': value['costsTransactionDepotNavPercent'],
    };
}

